import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getNavigations } from "../slices/navigationSlice";

const PrivateRoutes = ({ path, ...props }) =>
{

  //Navigation
  const Location = useLocation();

  //Redux
  const listNavigation = useSelector(getNavigations); 

  //Check if user has access
  const hasAccess = () => {

    if (Location.pathname == "/") return true;



    if (listNavigation.some(n => n.url == Location.pathname)) return true;


    return false;
  };

  let auth = false;
  let access = false;

  switch (props.type) {
    case "isAuth":
      auth = props.auth.isAuth;
      access = hasAccess();
      break;
    case "needFill":
      auth = true;
      access = true;
      break;
    case "toVerify":
      access = true;
      auth = props.auth.User;
      break;
    case "resetPassword":
      access = true;
      auth = props.auth.User;
      break;
    default:
      break;
  }


  //If authentificated but doesn't have access
  if (auth && !access)
    return <Navigate to="/" />;



  //Check if authentificated
  return (
    auth ? <Outlet /> : <Navigate to={"/auth/" + encodeURIComponent(Location.pathname + Location.search)} />
  );
};

export default PrivateRoutes;
